/**
 * OSI-818: форматирование полей общего акта. Вынесено отдельно, потому что одни и те же
 * период и сумма выводятся и в блоке общего акта, и в диалоге подписания.
 */

/** Период акта «месяц год» — так же, как в таблицах актов (NotSignedActs/SignedActs). */
export const formatActPeriod = (value: string | null | undefined): string => {
  if (!value) return '';

  return new Date(value).toLocaleString('ru-RU', { year: 'numeric', month: 'long' });
};

/** Сумма с двумя знаками; null/undefined — 0.00 (сумма строк у акта без строк приходит null). */
export const formatActAmount = (value: number | null | undefined): string => (value ?? 0).toFixed(2);
